var _a;
import baseTheme from '../baseTheme';
var MuiToolbar = {
    root: {},
    regular: (_a = {
            minHeight: 77
        },
        _a[baseTheme.breakpoints.up('sm')] = {
            minHeight: 77,
        },
        _a),
    dense: {
        minHeight: 38,
    },
};
export default MuiToolbar;
//# sourceMappingURL=MuiToolbar.js.map